export default "__VITE_ASSET__BlsIoPw2__"